// extracted by mini-css-extract-plugin
export default {"orangeBackground":"no-design-popup__orangeBackground___j8RGV","orangeSubHeader":"no-design-popup__orangeSubHeader___WeBIb"};